import * as React from 'react';
import { lazy, Suspense } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   Skeleton,
   UseDisclosureProps,
   useDisclosure,
   useBreakpointValue,
} from '@chakra-ui/react';
import {
   AlgoliaHitProps,
   TreeNavigationProps,
   WorkbenchDevice,
   SelectionProps,
} from 'device-picker';
import { getSearchClient } from 'Guide/searchClient';

const DevicePicker = lazy(() => import('device-picker'));

export const DevicePickerModal = ({
   onSelect,
   devicesInWorkbench,
   initialDevice,
   selectionProps,
   treeNavigationProps,
   showUncategorizedDevices,
   titleInstruction,
   ...disclosureProps
}: {
   onSelect: (_device: AlgoliaHitProps) => void;
   devicesInWorkbench?: WorkbenchDevice[];
   initialDevice?: string;
   selectionProps?: SelectionProps;
   treeNavigationProps?: TreeNavigationProps;
   showUncategorizedDevices?: boolean;
   titleInstruction?: string;
} & UseDisclosureProps) => {
   const { isOpen, onClose } = useDisclosure(disclosureProps);
   const isCentered = useBreakpointValue({ base: false, sm: true });
   const onSubmit = (device: AlgoliaHitProps) => {
      if (device.wikiid) {
         const apiRoute = `/api/2.0/user/topic/viewed/${device.wikiid}`;
         const variantid = device.variantid ? `/${device.variantid}` : '';
         navigator.sendBeacon(apiRoute + variantid);
      }
      onSelect(device);
   };
   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         scrollBehavior="inside"
         isCentered={isCentered}
         closeOnEsc
         closeOnOverlayClick
      >
         <ModalOverlay />
         <ModalContent
            p={0}
            my={0}
            height={{ base: '90dvh', sm: '85vh' }}
            maxHeight="100%"
            width="auto"
            maxWidth="100%"
            alignSelf={{ base: 'flex-end', sm: 'auto' }}
            borderRadius="8px"
         >
            <Suspense fallback={<Skeleton height="100%" width="100%" />}>
               <DevicePicker
                  algoliaConfig={
                     App.algoliaConfig && {
                        searchClient: getSearchClient(),
                        indexPrefix: App.algoliaConfig['indexPrefix'],
                     }
                  }
                  onSubmit={onSubmit}
                  onCancel={onClose}
                  objectName={App.objectNameSingular}
                  objectNamePlural={App.objectNamePlural}
                  langid={App.lang}
                  devicesInWorkbench={devicesInWorkbench}
                  initialDevice={initialDevice}
                  selectionProps={selectionProps}
                  treeNavigationProps={treeNavigationProps}
                  showUncategorizedDevices={showUncategorizedDevices}
                  titleInstruction={titleInstruction}
                  preferredStore={App.userPreferredStoreCode}
               />
            </Suspense>
         </ModalContent>
      </Modal>
   );
};
